import { render } from "./SaberWeights.vue?vue&type=template&id=dd801e2a&ts=true"
import script from "./SaberWeights.vue?vue&type=script&lang=ts"
export * from "./SaberWeights.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__